import Cookies from 'js-cookie'

export function getInfo(TokenKey) {
    return Cookies.get(TokenKey)
}

export function setInfo(TokenKey, data) {
    return Cookies.set(TokenKey, data)
}



export function removeInfo(TokenKey) {
    return Cookies.remove(TokenKey)
}